export default __webpack_public_path__ + "media/images/features/yado/step_3_text-1d0e2a85c95a33dbe6925c1d492923b5.png";